import { __decorate, __metadata } from "tslib";
import { EmbeddedConfigToken } from '@1inch-community/core/application-context';
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { appendStyle, getMobileMatchMedia, observe, subscribe, } from '@1inch-community/core/lit-utils';
import { SwapContextToken } from '@1inch-community/sdk/swap';
import '@1inch-community/ui-components/icon';
import { consume } from '@lit/context';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { combineLatest, defer, fromEvent, map, switchMap } from 'rxjs';
import { tokenPairSwitchStyle } from './token-pair-switch.style';
let TokenPairSwitchElement = class TokenPairSwitchElement extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
        this.iconRef = createRef();
        this.buttonRef = createRef();
        this.mobileMedia = getMobileMatchMedia();
        this.isUp = false;
        this.isDisabled$ = defer(() => {
            if (!this.swapContext)
                throw new Error('');
            return combineLatest([
                this.swapContext.getTokenByType('source'),
                this.swapContext.getTokenByType('destination'),
            ]);
        }).pipe(map(([sourceToken, destinationToken]) => !sourceToken || !destinationToken || this.config?.swapFromParams.disabledTokenChanging));
    }
    static { this.tagName = 'inch-token-pair-switch'; }
    static { this.styles = tokenPairSwitchStyle; }
    firstUpdated() {
        if (!this.buttonRef.value)
            return;
        if (this.config?.swapFromParams.disabledTokenChanging)
            return;
        if (!this.mobileMedia.matches) {
            const options = {
                duration: 200,
                easing: 'cubic-bezier(.1, .3, .6, 1)',
            };
            subscribe(this, [
                fromEvent(this.buttonRef.value, 'mouseenter').pipe(switchMap(async () => {
                    if (!this.iconRef.value || this.isUp)
                        return;
                    this.isUp = true;
                    await this.applicationContext.value.animations.animate(this.iconRef.value, [{ transform: 'rotate(0deg)' }, { transform: 'rotate(180deg)' }], options);
                    appendStyle(this.iconRef.value, {
                        transform: 'rotate(180deg)',
                    });
                })),
                fromEvent(this.buttonRef.value, 'mouseleave').pipe(switchMap(async () => {
                    if (!this.iconRef.value || !this.isUp)
                        return;
                    this.isUp = false;
                    await this.applicationContext.value.animations.animate(this.iconRef.value, [{ transform: 'rotate(180deg)' }, { transform: 'rotate(360deg)' }], options);
                    appendStyle(this.iconRef.value, {
                        transform: '',
                    });
                })),
            ]);
        }
    }
    render() {
        return html `
      <button
        ${ref(this.buttonRef)}
        @click="${() => this.onClick()}"
        ?disabled="${observe(this.isDisabled$, false)}"
        class="switcher"
      >
        <inch-icon ${ref(this.iconRef)} class="switcher-icon" icon="arrowDown24"></inch-icon>
      </button>
    `;
    }
    async onClick() {
        if (this.config?.swapFromParams.disabledTokenChanging)
            return;
        if (!this.iconRef.value || (!this.isUp && !this.mobileMedia.matches))
            return;
        this.swapContext?.switchPair();
        const options = {
            duration: 200,
            easing: 'cubic-bezier(.1, .3, .6, 1)',
        };
        if (!this.mobileMedia.matches) {
            await this.iconRef.value.animate([{ transform: 'rotate(180deg)' }, { transform: 'rotate(360deg)' }], options).finished;
            appendStyle(this.iconRef.value, {
                transform: '',
            });
            this.isUp = false;
        }
    }
};
__decorate([
    consume({ context: SwapContextToken }),
    __metadata("design:type", Object)
], TokenPairSwitchElement.prototype, "swapContext", void 0);
__decorate([
    consume({ context: EmbeddedConfigToken }),
    __metadata("design:type", Object)
], TokenPairSwitchElement.prototype, "config", void 0);
TokenPairSwitchElement = __decorate([
    customElement(TokenPairSwitchElement.tagName)
], TokenPairSwitchElement);
export { TokenPairSwitchElement };
//# sourceMappingURL=token-pair-switch.element.js.map